import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Button, Popover, Select } from 'antd';
import images from '../../themes/appImage'
import { useNavigate } from "react-router-dom";
import { Table, } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { innerCircleGlobalListLoad } from "../../redux/slices/inner.slice";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import { emptySpaceInputHandler } from "../../utils";



const numberOfRowOptionList = [
    { value: 'one', label: 10 },
    { value: 'two', label: 20 },
    { value: 'three', label: 25 },
]
let LIST_LIMIT = 10
let OFFSET = 0
let currentSortValue = -1
let sort = "createdAt"
const userListPayload = {
    "offset": 0,
    "limit": 10,
    "search": "",
    "sort": sort,
    "order": currentSortValue
}
const InnerCircle = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { globalListData } = useSelector(state => state.InnerCircleReducer)
    const [search, setSearch] = useState("")

    const columns = [
        {
            title: 'ID',
            dataIndex: 'srno',
            key: 'srno',
            sorter: false,
            render: (value, item, index) => (OFFSET + index + 1)
        },
        {
            title: 'Title  ',
            dataIndex: 'name',
            key: 'name',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            title: () => {
                return (
                    <div onClick={() => sortHandler("name")} className="sort-icons">
                        <span>Title</span> <img src={images.arrowLeft} alt="" />
                    </div>
                );
            },
        },

        {
            title: 'Total Users',
            dataIndex: 'users',
            key: 'users',
            sorter: false,
            render: (value, item, index) => <div className="organization-image-sec">
                {item.totalUser}
            </div>
        },

        {
            title: 'Engagement Rate',
            dataIndex: 'rate',
            key: 'rate',
            sorter: false,
            render: (value, item, index) => <div className="organization-image-sec">
                N/A
            </div>
        },

        {
            title: 'Date Created',
            dataIndex: 'date',
            key: 'date',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            title: () => {
                return (
                    <div onClick={() => sortHandler("createdAt")} className="sort-icons">
                        <span>Date Created</span> <img src={images.arrowLeft} alt="" />
                    </div>
                );
            },
            render: (value, item, index) => <div className="organization-image-sec">
                {moment(item.createdAt).format('MMMM D, YYYY')}
            </div>

        },

        {
            title: 'Last Activity',
            dataIndex: 'activity',
            key: 'activity',
            sorter: false,
            render: (value, item, index) => {
                return (
                    <div className="action-dots-iocn">
                        N/A
                    </div>
                )
            }
        },

        {
            title: 'Action',
            dataIndex: 'Posted',
            key: 'Posted',
            render: (value, item, index) => {
                return (

                    <Popover
                    content={
                      <Button
                        type="text"
                        onClick={() => {
                            navigate('/innercircletabs', {
                                state: {
                                    id: item._id,
                                }
                          });
                        }}
                      >
                        View
                      </Button>
                    }
                    trigger="click"
                  >
                      <div className="relative action-dots-iocn">
                    <span>
                      <img src={images.horizontalDots} />
                    </span>
                    </div>
                  </Popover>
                )
            }
        },
    ];

    useEffect(() => {
        dispatch(innerCircleGlobalListLoad(userListPayload))
    }, [])

    // P A G I N A T I O N 

    // --S T A T E--
    const START = useMemo(() => OFFSET + 1, [globalListData.getList]);
    const TOTAL_LIST_ITEMS = useMemo(() => globalListData.pagination?.totalCount, [globalListData.getList])
    const END = useMemo(() => (Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS)), [globalListData.getList]);
    const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS

    // --A C T I O N S--

    const paginationHandler = useCallback((type) => {
        if (type === "pre") {
            OFFSET = OFFSET - LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: sort,
                order: currentSortValue
            }
            dispatch(innerCircleGlobalListLoad(data));
        } else {
            OFFSET = OFFSET + LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: "createdAt",
                order: -1
            }
            dispatch(innerCircleGlobalListLoad(data));
        }
    }, [globalListData.getList])

    const numberOfRowHandler = useCallback((ddateStringate, dataObj) => {
        LIST_LIMIT = dataObj.label
        OFFSET = 0
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(innerCircleGlobalListLoad(data));
    }, [globalListData.getList])

    const searchHandler = useCallback((e) => {
        if (emptySpaceInputHandler(e) || e.target.value.length == "") {
            LIST_LIMIT = 10
            OFFSET = 0
            setSearch(emptySpaceInputHandler(e))
            const data = {
                offset: 0,
                limit: 10,
                search: emptySpaceInputHandler(e).trim(),
                order: -1
            }
            debounce(() => dispatch(innerCircleGlobalListLoad(data)))
        }
    }, [globalListData.getList]);

    const sortHandler = useCallback((sort) => {
        currentSortValue = currentSortValue == -1 ? 1 : -1
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(innerCircleGlobalListLoad(data));
    }, [globalListData.getList])
    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>
                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Inner Circle</h1>
                        {/* <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p> */}
                    </div>
                    {/* Version 2 */}
                    {/* <div className="add-new-button user-page-btn">
                        <button >Post Suggestions</button>
                        <button >Activities</button>
                    </div> */}
                </div>

                <div className="total-user inner-circle-grid">
                    <div className="user-count number-inner-cricle-ps">
                        <p>Number of Inner Circles</p>
                        <h1>{TOTAL_LIST_ITEMS}</h1>
                    </div>

                    <div className="user-count number-inner-cricle-ps">
                        <p>Number of Active Inner Circles</p>
                        <h1>{TOTAL_LIST_ITEMS}</h1>
                    </div>

                    {/* Version 2 */}
                    {/* <div className="user-count number-inner-cricle-ps">
                        <p>Suggested Activities</p>
                        <div className="post-active-flex">
                            <h1>10</h1>
                            <span onClick={() => {
                                navigate('/suggestedactivities')
                            }}>Manage</span>
                        </div>
                    </div>

                    <div className="user-count number-inner-cricle-ps">
                        <p>Post Suggestions </p>
                        <div className="post-active-flex">
                            <h1>10</h1>
                            <span onClick={() => {
                                navigate('/postsuggestions')
                            }}>Manage</span>
                        </div>
                    </div> */}











                </div>


                <div className="content-e">


                    <div class="bg-gradient-primary  system-line">
                        <input type="text" value={search} onChange={searchHandler} className="iocn-search  search-bar" placeholder="Search inner circle" />
                        {/* Version 2 */}
                        {/* <div className="top-checkbox">
                            <Select
                                defaultValue="Filter"
                                onChange={handleChange}
                                options={[
                                    { value: 'one', label: '1 months' },
                                    { value: 'two', label: '3 months' },
                                    { value: 'three', label: '6 months' },

                                ]}
                            />
                        </div> */}
                    </div>

                    <Table
                        dataSource={globalListData.getList}
                        columns={columns}
                        showSorterTooltip={false}
                        pagination={{
                            current: 0,
                            pageSize: 0,
                            total: TOTAL_LIST_ITEMS,
                        }}
                    />

                    {TOTAL_LIST_ITEMS > 10 && <div className="footer-section">
                        <div className="foot-main-div">
                            <div className="rows">
                                <div className="row-per-page">
                                    <p>Rows per page</p>
                                </div>
                                <div className="top-checkbox fot-select">
                                    <Select
                                        defaultValue={LIST_LIMIT}
                                        onChange={numberOfRowHandler}
                                        options={numberOfRowOptionList}
                                    />
                                </div>
                            </div>

                            <div className="page-count">
                                <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                            </div>

                            <div className="back-and-next">
                                {/* <span><img src={images.back} alt="back" /></span> */}
                                <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={OFFSET == 0 ? images.per : images.paginationDimLeft} style={{ tintColor: "red" }} alt="back" /></span>
                                <span onClick={() => canCallNextData && paginationHandler("next")}><img src={canCallNextData == false ? images.paginationDimRight : images.new} alt="back" /></span>
                                {/* <span><img src={images.next} alt="back" /></span> */}
                            </div>

                        </div>

                    </div>}
                </div>
            </div>



        </div>

    )
}
export default InnerCircle;

